/*=========================================================================================
  File Name: moduleContactGetters.js
  Description: Contact Module Getters
  ----------------------------------------------------------------------------------------
==========================================================================================*/


export default {

}